import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["kindSelect", "statusPresetWrapper", "odontogramBehaviorWrapper", "odontogramBehaviorSelect", "symbolCodeWrapper", "billingBehaviorWrapper"]

  connect() {
    this.toggleStatusField()
    this.toggleSymbolCodeField()
  }

  kindChanged() {
    this.toggleStatusField()
  }

  odontogramBehaviorChanged() {
    this.toggleSymbolCodeField()
  }

  toggleStatusField() {
    const kindValue = this.kindSelectTarget.value
    const statusWrapper = this.statusPresetWrapperTarget

    if (kindValue === "general") {
      statusWrapper.classList.add("hidden")
    } else {
      statusWrapper.classList.remove("hidden")
    }

    if (this.hasOdontogramBehaviorWrapperTarget) {
      this.odontogramBehaviorWrapperTarget.classList.toggle("hidden", kindValue === "general")
    }

    if (this.hasBillingBehaviorWrapperTarget) {
      this.billingBehaviorWrapperTarget.classList.toggle("hidden", kindValue === "general")
    }

    this.toggleSymbolCodeField()
  }

  toggleSymbolCodeField() {
    if (!this.hasSymbolCodeWrapperTarget) return

    const symbolWrapper = this.symbolCodeWrapperTarget
    const kindValue = this.kindSelectTarget.value

    if (kindValue === "general" || !this.hasOdontogramBehaviorSelectTarget) {
      symbolWrapper.classList.add("hidden")
      return
    }

    const behaviorValue = this.odontogramBehaviorSelectTarget.value
    if (behaviorValue === "symbol") {
      symbolWrapper.classList.remove("hidden")
    } else {
      symbolWrapper.classList.add("hidden")
    }
  }
}
